module.exports = __webpack_public_path__ + "static/media/text.36bdc00a.jpg";